import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class Sensor extends Base {
  /**
   * @description List location API function
   * @returns {Promise<Response>}
   */
  list() {
    const url = this._getFullURL(`/sensor`);
    return this._secureFetch(url);
  }

  /**
   * @description Create location API function
   * @param {object} payload
   * @param fileInput
   * @returns {Promise<Response>}
   */
  create(payload) {
    const url = this._getFullURL("/sensor");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  createBearing(payload) {
    const url = this._getFullURL("/sensor/live/bearing");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  addAnnotation(payload) {
    const url = this._getFullURL("/sensor/live/annotation");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  featuresById(payload, machine_element) {
    const url = this._getFullURL(
      "/sensor/live/custom?machine_element=" + machine_element
    );

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }

  deploy(payload) {
    const url = this._getFullURL("/sensor");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }

  /**
   * @description Get location API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  get(id) {
    const url = this._getFullURL(`/sensor/${id}`);
    return fetch(url, this._generateRequestBody({}));
  }

  liveVibration(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/sensor/live/vibration?${queryParam}`);
    return fetch(url, this._generateRequestBody({}));
  }

  downloadVibration(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/sensor/live/download?${queryParam}`);
    return fetch(url, this._generateRequestBody({}));
  }

  customChart(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/sensor/live/custom?${queryParam}`);
    return fetch(url, this._generateRequestBody({}));
  }
  getBearing(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/sensor/live/bearing?${queryParam}`);
    return fetch(url, this._generateRequestBody({}));
  }

  chartEnvelopeFFT(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/sensor/live/envelope-fft?${queryParam}`);
    return fetch(url, this._generateRequestBody({}));
  }

  getAccelerationWave(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/sensor/live/acceleration?${queryParam}`);
    return fetch(url, this._generateRequestBody({}));
  }

  getAccelerationList(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/sensor/live/acclist?${queryParam}`);
    return fetch(url, this._generateRequestBody({}));
  }

  getAnnotation(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/sensor/live/annotation?${queryParam}`);
    return fetch(url, this._generateRequestBody({}));
  }

  getAnnotationMachine(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(
      `/sensor/live/annotation-machine?${queryParam}`
    );
    return fetch(url, this._generateRequestBody({}));
  }

  getRawData(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/sensor/live/raw?${queryParam}`);
    return fetch(url, this._generateRequestBody({}));
  }

  liveIndexData(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/sensor/live/index?${queryParam}`);
    return fetch(url, this._generateRequestBody({}));
  }

  liveSpeed(query) {
    const url = this._getFullURL("/wings-api");

    return fetch(
      url,
      this._generateRequestBody({ payload: query, method: "POST" })
    );
  }

  liveTemperature(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/sensor/live/temperature?${queryParam}`);
    return fetch(url, this._generateRequestBody({}));
  }

  liveSound(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/sensor/live/sound?${queryParam}`);
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Update location API function
   * @param {string} id
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  update = (id, payload) => {
    const url = this._getFullURL(`/sensor?sensor_id=${id}`);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: JSON.stringify(payload),
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  };

  /**
   * @description Delete location API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  delete = (id) => {
    const url = this._getFullURL(`/sensor/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
  deleteAnnotation = (id) => {
    const url = this._getFullURL(`/sensor/live/annotation?id=${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
}
